import httpClient from '@src/services/http.service'
import {getSavedState, saveState} from '@state/helpers'

const language = 'language'

export const state = {
  translationsData: {},
  languages: [],
  language: 'en',
  isLoading: true,
  isTranslated: false,
}

export const getters = {
  currentLanguage: state => state.language.toLowerCase(),
  languagesList: state => state.languages,
  translations: state => state.translationsData,
  isLoading: state => state.isLoading,
  isTranslated: state => state.isTranslated,
}

export const mutations = {
  SET_TRANSLATIONS: (state, translations) => {
    state.translationsData = translations
  },
  SET_AVAILABLE_LANGUAGES: (state, languages) => {
    state.languages = languages
  },
  SET_LANGUAGE: (state, lang) => {
    state.language = lang
    saveState(language, lang)
  },
  SET_IS_TRANSLATED: (state, value) => {
    state.isTranslated = value
  },
  loadingState: (state, { isLoading }) => {
    state.isLoading = isLoading
  }
}

export const actions = {
  init: ({ commit }) => {
    // commit('loadingState', { isLoading: true })
    Promise.all([httpClient.get('translation'), httpClient.get('languages/active')])
      .then(([translations, languages]) => {
        commit('SET_TRANSLATIONS', translations.data)
        commit('SET_AVAILABLE_LANGUAGES', languages.data)
        commit('loadingState', { isLoading: false })

        if (localStorage.getItem(language)) {
          commit('SET_LANGUAGE', getSavedState(language))
        } else {
          saveState(language, 'en')
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
}
